import { render, staticRenderFns } from "./alpha.vue?vue&type=template&id=5c111d46&"
import script from "./alpha.vue?vue&type=script&lang=js&"
export * from "./alpha.vue?vue&type=script&lang=js&"
import style0 from "./alpha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports